import { Map } from '../map/map';
import { Copromote } from '../copromote/copromote';
import { Description } from '../event/description';
import { BuyTicketsWidget } from '../modals/tickets'
import { HashHandler } from '../hash_handler';
import { ModalTemplate } from '../modals/template';
import { getEventManageProfileServices } from './event-manage-services';
import { NewEventModal } from '../modals/new_event';

require('jquery-jeditable');
/**
 * Event
 */
class Event {
    constructor(eventId, userId, isNewEvent,settings) {
        this.locked = false;

        this.eventId = eventId;
        this.userId = userId;
        this.isNewEvent = isNewEvent;

        this.rsvpStatus = typeof settings.rsvp == 'undefined' ? 1 : settings.rsvp;
        this.goingLocked = !!settings.goingLocked;
        this.texts = settings.texts;

        this.lat = settings.lat;
        this.lng = settings.lng;

        this.perms = settings.perms;

        this.future = settings.future;
        this.shareData = settings.share || {};
        this.sharePopoverOpen = false;
        this.moreMenuOpen = false;
        this.moreCopyResetTimeout = null;

        new Map(this);
        new Copromote(this);

        this.initEditables();
        this.initPeopleRSVPWidget();

        var that = this;

        $("#imageupload").change(function(e) {
            $("#pictureForm").submit();
        });

        that._initUrlImagePreview();
        that._initSharePopover();
        that._initMoreMenu();

        // hash handler
        this.hashHandler = new HashHandler();

        this.hashHandler.addAction('#discussions-box', false, function() {
            $('a[href="#discussions-box"]').click();
        });

        this.hashHandler.addAction('#share', false, function() {
            profile.shareEvent(that.eventId);
            if(evedo.isLogged()) that.hashHandler.clearHash();
        });

        this.hashHandler.addAction('#rsvp', true, function(status) {
            that.rsvp(parseInt(status));
            if(evedo.isLogged()) that.hashHandler.clearHash();
        });

        this.hashHandler.addAction('#accept-invite', true, function(inviteId) {
            that.acceptInvite(parseInt(inviteId));
            if(evedo.isLogged()) that.hashHandler.clearHash();
        });

        this.hashHandler.addAction('#decline-invite', true, function(inviteId) {
            that.declineInvite(parseInt(inviteId));
            if(evedo.isLogged()) that.hashHandler.clearHash();
        });

        this.hashHandler.addAction('#accept-request', true, function(requestId) {
            that.acceptRequest(parseInt(requestId));
            if(evedo.isLogged()) that.hashHandler.clearHash();
        });

        this.hashHandler.addAction('#decline-request', true, function(requestId) {
            that.declineRequest(parseInt(requestId));
            if(evedo.isLogged()) that.hashHandler.clearHash();
        });

this.hashHandler.addAction('#buy-tickets', false, function() {
    if(that.buyTicketsWidget) {
        that.buyTicketsWidget.button.click();
    }
});

this.hashHandler.addAction('#buy-tickets-finish', true, function(orderId) {
    profile.buyTickets(that.eventId, null, { finishOrderId: orderId });
    that.hashHandler.clearHash();
});

        if(this.isNewEvent){
            this.newEventModalShow();
        }
        // refresh
        setTimeout(function() {
            that._refresh();
        }, 30000);
    }

    _lock() {
        this.locked = true;
    }

    _unlock() {
        this.locked = false;
    }

    _canUseNativeShare() {
        return window.matchMedia('(max-width: 767px)').matches
            && typeof navigator.share === 'function';
    }

    _buildShareUrls() {
        var data = this.shareData || {};
        var url = encodeURIComponent(data.url || '');
        var title = encodeURIComponent(data.title || '');
        var description = encodeURIComponent(data.description || '');

        return {
            facebook: 'https://www.facebook.com/sharer/sharer.php?u=' + url,
            linkedin: 'https://www.linkedin.com/shareArticle?mini=true&url=' + url
                + '&title=' + title
                + '&summary=' + description
                + '&source=' + encodeURIComponent('Plentix'),
            twitter: 'https://twitter.com/intent/tweet?url=' + url + '&text=' + title
        };
    }

    _openShareWindow(shareUrl) {
        window.open(
            shareUrl,
            'sharewindow',
            'width=800,height=410,toolbar=0,scrollbars=0,status=0,resizable=0,location=0,menuBar=0,left=' + ((screen.width - 800) / 2) + ',top=' + ((screen.height - 410) / 2)
        );
    }

    _initSharePopover() {
        var that = this;
        var $popover = $('#event-share-popover');

        if (!$popover.length) {
            return;
        }

        $popover.on('click', 'a[data-share-platform]', function(e) {
            e.preventDefault();
            e.stopPropagation();
            var platform = $(this).data('share-platform');
            var urls = that._buildShareUrls();

            if (urls[platform]) {
                that._openShareWindow(urls[platform]);
            }

            that._closeSharePopover();
        });

        $popover.on('click', '[data-share-copy]', function(e) {
            e.preventDefault();
            e.stopPropagation();
            that._copyShareLink($(this));
        });

        $(document).on('click.eventSharePopover', function(e) {
            if (!that.sharePopoverOpen) {
                return;
            }

            if ($(e.target).closest('.ev-share-wrap').length) {
                return;
            }

            that._closeSharePopover();
        });

        $(document).on('keydown.eventSharePopover', function(e) {
            if (e.key === 'Escape' && that.sharePopoverOpen) {
                that._closeSharePopover();
            }
        });
    }

    _openSharePopover() {
        var $popover = $('#event-share-popover');

        if (!$popover.length) {
            return;
        }

        $popover.removeAttr('hidden').attr('aria-hidden', 'false');
        this.sharePopoverOpen = true;
    }

    _closeSharePopover() {
        var $popover = $('#event-share-popover');

        if (!$popover.length) {
            return;
        }

        $popover.attr('hidden', 'hidden').attr('aria-hidden', 'true');
        this.sharePopoverOpen = false;
    }

    _toggleSharePopover() {
        if (this.sharePopoverOpen) {
            this._closeSharePopover();
        } else {
            this._openSharePopover();
        }
    }

    _copyShareLink($button) {
        var text = (this.shareData.title || '') + '\n' + (this.shareData.url || '');
        var copiedLabel = (this.texts && this.texts.linkCopied) ? this.texts.linkCopied : 'Link copied';
        var originalLabel = $button.attr('aria-label') || $button.attr('title') || '';
        var that = this;

        var onCopied = function() {
            $button.attr('aria-label', copiedLabel).attr('title', copiedLabel);
            setTimeout(function() {
                $button.attr('aria-label', originalLabel).attr('title', originalLabel);
            }, 2000);
        };

        if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
            navigator.clipboard.writeText(text).then(onCopied).catch(function() {
                if (that._copyShareLinkFallback(text)) {
                    onCopied();
                }
            });
            return;
        }

        if (this._copyShareLinkFallback(text)) {
            onCopied();
        }
    }

    _copyShareLinkFallback(text) {
        var textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.setAttribute('readonly', '');
        textarea.style.position = 'absolute';
        textarea.style.left = '-9999px';
        document.body.appendChild(textarea);
        textarea.select();

        var copied = false;

        try {
            copied = document.execCommand('copy');
        } catch (e) {
            copied = false;
        }

        document.body.removeChild(textarea);

        return copied;
    }

    _initMoreMenu() {
        var that = this;
        var $menu = $('#event-more-menu');

        if (!$menu.length) {
            return;
        }

        $menu.on('click', '[data-more-copy]', function(e) {
            e.preventDefault();
            e.stopPropagation();
            that._copyMoreLink($(this));
        });

        $menu.on('click', '[data-more-calendar]', function(e) {
            e.preventDefault();
            e.stopPropagation();
            that._closeMoreMenu();
            $('#event-calendar-modal').modal('show');
        });

        $(document).on('click.eventMoreMenu', function(e) {
            if (!that.moreMenuOpen) {
                return;
            }

            if ($(e.target).closest('.ev-more-wrap').length) {
                return;
            }

            that._closeMoreMenu();
        });

        $(document).on('keydown.eventMoreMenu', function(e) {
            if (e.key === 'Escape' && that.moreMenuOpen) {
                that._closeMoreMenu();
            }
        });
    }

    _openMoreMenu() {
        var $menu = $('#event-more-menu');
        var $trigger = $('.ev-more-wrap .rsvp-btn-more');

        if (!$menu.length) {
            return;
        }

        $menu.removeAttr('hidden').attr('aria-hidden', 'false');
        $trigger.attr('aria-expanded', 'true');
        this.moreMenuOpen = true;
    }

    _closeMoreMenu() {
        var $menu = $('#event-more-menu');
        var $trigger = $('.ev-more-wrap .rsvp-btn-more');

        if (!$menu.length) {
            return;
        }

        this._resetMoreCopyItem();
        $menu.attr('hidden', 'hidden').attr('aria-hidden', 'true');
        $trigger.attr('aria-expanded', 'false');
        this.moreMenuOpen = false;
    }

    _getMoreCopyTickIconHtml() {
        return '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_more_copy_tick)"><path d="M4 11.1429L7.6 15L16 6" stroke="#49494F" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/></g><defs><clipPath id="clip0_more_copy_tick"><rect width="20" height="20" fill="white"/></clipPath></defs></svg>';
    }

    _resetMoreCopyItem() {
        var $item = $('[data-more-copy]', '#event-more-menu');

        if (this.moreCopyResetTimeout) {
            window.clearTimeout(this.moreCopyResetTimeout);
            this.moreCopyResetTimeout = null;
        }

        $item.removeClass('ev-more-menu__item--copied');
        $item.find('.ev-more-menu__item-icon').each(function() {
            var $icon = $(this);

            if ($icon.data('copy-icon-html')) {
                $icon.html($icon.data('copy-icon-html'));
            }
        });
        $item.find('.ev-more-menu__item-label').each(function() {
            var $label = $(this);

            if ($label.data('copy-label-text')) {
                $label.text($label.data('copy-label-text'));
            }
        });
    }

    _showMoreCopySuccess($item) {
        var that = this;
        var $icon = $item.find('.ev-more-menu__item-icon');
        var $label = $item.find('.ev-more-menu__item-label');
        var copiedLabel = (this.texts && this.texts.copied) ? this.texts.copied : 'Copied';

        if (!$icon.data('copy-icon-html')) {
            $icon.data('copy-icon-html', $icon.html());
        }

        if (!$label.data('copy-label-text')) {
            $label.data('copy-label-text', $label.text());
        }

        this._resetMoreCopyItem();
        $item.addClass('ev-more-menu__item--copied');
        $icon.html(this._getMoreCopyTickIconHtml());
        $label.text(copiedLabel);

        this.moreCopyResetTimeout = window.setTimeout(function() {
            that.moreCopyResetTimeout = null;
            that._resetMoreCopyItem();
        }, 2000);
    }

    _copyMoreLink($item) {
        var text = (this.shareData && this.shareData.url) ? this.shareData.url : window.location.href;
        var that = this;

        var onCopied = function() {
            that._showMoreCopySuccess($item);
        };

        if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
            navigator.clipboard.writeText(text).then(onCopied).catch(function() {
                if (that._copyShareLinkFallback(text)) {
                    onCopied();
                }
            });
            return;
        }

        if (this._copyShareLinkFallback(text)) {
            onCopied();
        }
    }

    toggleMoreMenu() {
        if (this.sharePopoverOpen) {
            this._closeSharePopover();
        }

        if (this.moreMenuOpen) {
            this._closeMoreMenu();
        } else {
            this._openMoreMenu();
        }
    }

    share() {
        if (!this.shareData || !this.shareData.url) {
            return;
        }

        var that = this;

        if (this.moreMenuOpen) {
            this._closeMoreMenu();
        }

        if (this._canUseNativeShare()) {
            navigator.share({
                title: this.shareData.title || '',
                text: this.shareData.description || '',
                url: this.shareData.url
            }).catch(function(error) {
                if (error && error.name === 'AbortError') {
                    return;
                }

                that._toggleSharePopover();
            });

            return;
        }

        this._toggleSharePopover();
    }

    _refresh() {
        var that = this;
        if (isNaN(parseInt(that.userId)) || !parseInt(that.userId))
            return false;
        that.loadComments($('#discussions-box div.paging a.active').html());

        setTimeout(function() {
            that._refresh();
        }, 30000);
    }

    _initUrlImagePreview() {
        $('#event_description a[href], #discussions-box a[href], #reviews-box a[href]')
            .on('mouseover', 'a', function(e) {
                if (!/(jpg|gif|png)$/.test($(this).attr('href'))) {
                    return false;
                }
                else {
                    var containerOffset = Math.ceil(($(document).width() - 980) * 0.5);
                    var imageBox = null;
                    var offsetLeft = 0;
                    var that = $(this);

                    $('body').append(
                        '<div id="url-image-preview">' +
                            '<img alt="" id="url-image-preview-image" src="'+ $(this).attr('href') +'" />' +
                        '</div>'
                    );

                    imageBox = $('#url-image-preview');

                    $('#url-image-preview-image').load(function() {
                        imageBox.css({
                            marginTop: imageBox.height() * -0.5,
                            opacity: 1.0,
                            top: that.offset().top + 3
                        });

                        offsetLeft = that.offset().left + that.width() + 15;

                        if(offsetLeft + imageBox.width() + 10 >= containerOffset + 760 && that.width() <= 250) {
                            imageBox.addClass('position-left').css({
                                right: $(document).width() - that.offset().left + 15
                            });
                        }
                        else {
                            imageBox.addClass('position-right').css({
                                left: offsetLeft
                            });
                        }
                    });
                }})
            .on('mouseout', 'a', function () { $("#url-image-preview").remove();})
            .on('click', 'a', function () { $("#url-image-preview").remove();});
    }

    rsvp(status) {
        if(this.locked) return;

        if (this.goingLocked && (status === 1 || status === 2)) {
            if (status === 1 || $('.rsvp-btn-1').hasClass('selected')) {
                return;
            }
        }

        profile.rsvp(this.eventId, status, true, () => {
            $("#event .rsvp-marker").each((k, v) => {
                $(v).addClass("disabled");
            });

            $("#event .rsvp-marker.rsvp-" + status).removeClass("disabled");
        })
    }

    rate(rating, review) {
        if (!window.evedo.isLogged()) {
            window.evedo.openLogin();
            return;
        }
        if (this.locked) return;

        var that = this;
        this._lock();

        if($("#event-rating-overlay").parent().attr('rel') == 'tooltip') {
            $("#event-rating-overlay").parent()
            .tooltip('hide')
            .attr('data-original-title', that.texts.thanksForVoting)
            .tooltip('fixTitle');
            if (!review)
                $("#event-rating-overlay").parent().tooltip('show');
        }
        else {
            $("#event-rating-overlay").parent()
            .attr('rel', 'tooltip')
            .attr('title', that.texts.thanksForVoting)
            .tooltip({ animation: false });
            if (!review)
                $("#event-rating-overlay").parent().tooltip('show');
        }

        $("#event-rating-overlay").parent()
            .attr('data-original-title', that.texts.voted.replace(/%d/, rating))
            .tooltip('fixTitle');

        $("#event-rating-overlay").css('width', Math.round((rating / 5) * 100) + '%');

        if (!review) {
            $.ajax({
                url: "/event/rate/", dataType: 'json', type: 'post',
                data: {id: this.eventId, rating: rating},
                success: function(data) {
                    if (data && data.success != undefined && data.success) {
                        $("#event-rating-overlay").css('width', data.ratingPercentage + '%');

                        that._unlock();
                    } else {
                        that._unlock();
                    }
                }
            });
        }
    }

    comment(msg) {
        if (!window.evedo.isLogged()) {
            window.evedo.openLogin();
            return;
        }
        if (this.locked) return;

        var that = this;
        this._lock();

        // $.ajax({
        //     url: "/event/comment/", dataType: 'json', type: 'post',
        //     data: {id: this.eventId, text: msg},
        //     success: function(data) {
        //         if (data && data.success != undefined && data.success) {
        //             $("#discussions-box .item, #discussions-box .paging").remove();
        //             $("#discussions-box").prepend(data.comments);
        //             $("#discussions-box textarea[name='message']").val('');
        //             $("#comments-count").html(data.commentsCount);
        //             $("#discussions-box .no-items").remove();

        //             that._unlock();
        //             $.ajax({
        //                 url: "/event/comment-facebook/", dataType: 'json', type: 'post',
        //                 data: {id: that.eventId},
        //                 success: function(data) {

        //                 }
        //             });
        //             $.ajax({
        //                 url: "/event/comment-twitter/", dataType: 'json', type: 'post',
        //                 data: {id: that.eventId},
        //                 success: function(data) {

        //                 }
        //             });
        //         } else {
        //             that._unlock();
        //         }
        //     }
        // });
    }

    loadComments(on_page) {
        if (this.locked) return;

        var that = this;
        this._lock();

        // $.ajax({
        //     url: "/event/comments/", dataType: 'json', type: 'post',
        //     data: {id: this.eventId, page: on_page},
        //     success: function(data) {
        //         if (data && data.success != undefined && data.success) {
        //             $("#discussions-box .item, #discussions-box .paging").remove();

        //             if (data.commentsCount > 0) {
        //                 $("#discussions-box div.no-items").remove();
        //                 $("#comments-count").html(data.commentsCount);
        //                 $("#discussions-box").prepend(data.comments);
        //             }

        //             that._unlock();
        //         } else {
        //             that._unlock();
        //         }
        //     }
        // });
    }

    cancelEvent() {
        var that = this;

        if(!window.confirm(that.texts.deleteEvent)) {
            return;
        }

        $.ajax({
            url: '/event/cancel/',
            dataType: 'json',
            method: 'post',
            data: {
                id: that.eventId
            },
            success: function(data) {
                if (data && data.success != undefined && data.success) {
                    window.location = '/';
                }
            }
        });
    }

    show() {
        var that = this;

        // debugger;
        // initTabs();

        // linked events
        var linkedEventsBox = $('div.linked-events');

        if(linkedEventsBox.length) {
            var linkedEventsListId = linkedEventsBox.data('id');
            var linkedEventsPaging = $('nav.paging a', linkedEventsBox);

            $('a.expand', linkedEventsBox).click(function() {
                linkedEventsBox.addClass('transition').toggleClass('expanded');

                if(linkedEventsBox.hasClass('expanded')) {
                    $.cookie('linked_list_' + linkedEventsListId + '_opened', true, { expires: 1, path: '/' });
                }
                else {
                    $.removeCookie('linked_list_' + linkedEventsListId + '_opened', { path: '/' });
                }

                return false;
            });

            if(linkedEventsPaging.length) {
                linkedEventsPaging.click(function() {
                    linkedEventsPaging.removeClass('active');
                    $(this).addClass('active');

                    $('div.mask', linkedEventsBox).animate(
                        { scrollLeft: $(this).index() * 620 },
                        { duration: 500, queue: false }
                    );

                    return false;
                });
            }
        }

        // rating
        $('div.event').find('div.rating').find('a').each(function() {
            $(this)
            .mouseover(function() { $(this).parent().addClass('no-background'); })
            .mouseout(function() { $(this).parent().removeClass('no-background'); });
        });

        // actions
        if($('section.summary').hasClass('vertical')) {
            var imageWidth = $('div.image img', 'section.summary').width();

            $('section.summary').find('div.information').width(730 - imageWidth);
            $('section.summary').find('div.social').css('marginLeft', Math.floor((730 - imageWidth - 40 - 245) * 0.5) + 2);
        }

        // description
        this.description = new Description();

        // cohosts

        if(window.evedo.isLogged()) {
            var cohostsInput = $('input[name="cohost"]');
            var copromoteRequestWidget = $('#copromote-request-widget');

            if (cohostsInput.length) {
                cohostsInput.autocomplete({
                    autoFocus: true,
                    source: function( request, response ) {
                        $.ajax({
                            url: "/common/token-hosts/",
                            dataType: "json",
                            minChars: 2,
                            data: {
                                q: $('input[name="cohost"]').val()
                            },
                            success: function( data ) {
                                response( $.map( data, function( item ) {
                                    return {
                                        label: item.name,
                                        value: item.name,
                                        id: item.id,
                                        image: item.image
                                    }
                                }));
                            }
                        });
                    },
                    change: function(event, ui) {
                        if(ui.item !== null && ui.item.id !== null)
                            $("#cohost-hidden").val(ui.item.id);
                        else
                            $("#cohost-hidden").val('');
                    },
                    select: function(event, ui) {
                        $("#cohost-hidden").val(ui.item.id);
                        that.addCohost();
                    }
                });

                cohostsInput.data('ui-autocomplete')._renderItem = function(ul, item) {
                    return $('<li class="autocomplete-image-item"></li>')
                        .data('item.autocomplete', item)
                        .append('<a href="#"><img src="' + item.image + '">' + item.label + '</a>')
                        .appendTo(ul);
                }
            }

            if (copromoteRequestWidget.length) {
                new CopromoteRequestWidget(copromoteRequestWidget, this.eventId);
            }
        }

        // buy tickets widget
        this.buyTicketsWidget = $('.sidebar-widget#buy-tickets-widget');

        if(this.buyTicketsWidget.length) {
            this.buyTicketsWidget = new BuyTicketsWidget(this.buyTicketsWidget, this.eventId, {
                texts: that.texts.buyTicketsWidget
            });
        }
        else {
            this.buyTicketsWidget = null;
        }
    }

    initPeopleRSVPWidget() {
        var peopleRSVPWidget = $('.people-rsvp-widget');

        if (peopleRSVPWidget.length) {
            peopleRSVPWidget.find('div > a').on('click', function() {
                $.ajax({
                    url: "/event/invitees-widget/",
                    dataType: 'json',
                    type: 'post',
                    data: {
                        id: $('div.event').data('event'),
                        page: $(this).data('page')
                    },
                    success: function(data) {
                        if (data) {
                            peopleRSVPWidget.html(data);
                        }
                    }
                });
            });
        }
    }

    initEditables() {
        var that = this;

        if (!that.perms.mainInfo || !that.future)
            return;

        // name
        $('.editable-name').editable('/event/save-single/?event=' + $('div.event').data('event'), {
            cssclass    : 'jeditable name',
            type        : 'text',
            loadtext    : that.texts.saving,
            placeholder : that.texts.clickToEdit,
            onblur      : 'submit',

            onsubmit    : function (settings, original) {
                if (original.revert == $('input',this).val() || $.trim($('input',this).val()).length == 0) {
                    original.reset();
                    return false;
                }
            }
        });

        // short-description
        $('.editable-short-description').editable('/event/save-single/?event=' + $('div.event').data('event'), {
            cssclass    : 'jeditable short-description',
            type        : 'text',
            loadtext    : that.texts.saving,
            placeholder : that.texts.clickToEdit,
            onblur      : 'submit',

            onsubmit    : function (settings, original) {
                if (original.revert == $('input',this).val()) {
                    original.reset();
                    return false;
                }
            }
        });

        // description
        $('.editable-description').editable('/event/save-single/?event=' + $('div.event').data('event'), {
            cssclass    : 'jeditable description',
            type        : 'textarea',
            loadtext    : that.texts.saving,
            placeholder : that.texts.clickToEdit,
            onblur      : 'submit',

            data        : function (original, settings) {
                original = $('<div>' + original + '</div>');

                $('a', original).each(function (key, el) {
                    $(el).text($(el).attr('href'));
                });

                return original.text();
            },

            onedit      : function (settings, original) {
                $("#url-image-preview").remove();
                that.description.reset(true);
            },

            onsubmit    : function (settings, original) {
                if (original.revert == $('textarea', this).val() || $.trim($('textarea', this).val()).length == 0) {
                    original.reset();
                    return false;
                }
            },

            callback    : function(value, settings) {
                that.description.reset();
                that.description.expand(true);
            }
        });
    }

    featureEvent() {
        profile.featureEvent(this.eventId, function(data) {
            var campaignsPanel = $('.round-buttons.featured-campaigns');

            if(data.success) {
                window.setTimeout(function() {
                    campaignsPanel.addClass('available bounce');
                }, 250);

                window.setTimeout(function() {
                    campaignsPanel.removeClass('bounce');
                }, 750);
            }
        });
    }

    featuredReport() {
        profile.featuredEventReport(this.eventId);
    }

    openBillingInformation() {
        getEventManageProfileServices(this.userId).openBillingInformation(this.eventId);
    }

    embedTickets() {
        getEventManageProfileServices(this.userId).embedTickets(this.eventId);
    }

    manageDiscountCodes() {
        getEventManageProfileServices(this.userId).manageDiscountCodes(this.eventId);
    }

    newEventModalShow(callback) {
        if(window.activeModalInstance) {
            return;
        }

        if(!this.newEventModal) {
            this.newEventModal = new ModalTemplate('new-event-modal', { keyboard: false });
        }

        window.activeModalInstance = new NewEventModal(this.newEventModal, this.eventId, callback);
    }

    featuredChange() {
        var that = this;

        $.ajax({
            url: '/event/change-featured',
            dataType: 'json',
            method: 'post',
            data: {
                id: that.eventId,
                featured: $('#featured-chbx').is(":checked")
            }
        }).done(function(data){
            window.location.reload();
        });
    }

    privateChange() {
        var that = this;

        $.ajax({
            url: '/event/change-public',
            dataType: 'json',
            method: 'post',
            data: {
                id: that.eventId,
                private: $('#private-chbx').is(":checked")
            }
        }).done(function(data){
            window.location.reload();
        });
    }

    soldOutChange() {
        var that = this;

        $.ajax({
            url: '/event/change-sold-out',
            dataType: 'json',
            method: 'post',
            data: {
                id: that.eventId,
                sold_out: $('#sold-out-chbx').is(":checked")
            }
        }).done(function(data){
            window.location.reload();
        });
    }
}

export { Event }
